import { withInstall } from "../utils/index.mjs";
import _Steps from "./Steps.mjs";
const Steps = withInstall(_Steps);
var stdin_default = Steps;
import { stepsProps } from "./Steps.mjs";
export {
  Steps,
  stdin_default as default,
  stepsProps
};
